import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import cn from './../../../../lib/bem';
import {
  addRegistroDatos,
  patchActualizarInformacion,
  postCaptcha,
  postValidarCreatePersona,
  resetState,
} from './../../../../redux/reducers/simuladorFVGSlice';
import ico_cancel_circle from './../../../../assets/svg/ico_cancel_circle.svg';
import InputDateComponent from './../../../../components/inputDate/inputDate_component';
import InputTextComponent from './../../../../components/inputText/inputText_component';
import InputCheckComponent from './../../../../components/inputCheck/inputCheck_component';
import InputSelectComponent from './../../../../components/inputSelect/inputSelect_component';
import ButtonComponent from './../../../../components/button/button_component';
import img_persona_laptop from './../../../../assets/svg/img_persona_laptop.svg';
import {
  validarCorreo,
  validateDateFormat,
  validateAge,
  obtenerFechaNacimiento,
} from './../../../../lib/utils';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import './modalDatosPersonales_Component.scss';
import { gtmOnclickCompletarDatos, gtmOnclickContinuar } from '../../../../gtm/datos-personales';

const ModalDatosPersonalesComponent = (props) => {
  const classes = cn('modalDatosPersonalesComponent');
  const dispatch = useDispatch();
  const history = useNavigate();

  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);

  const [nombre, guardarNombre] = useState(simuladorFVG.nombre);
  const [msgNombre, guardarMsgNombre] = useState('');
  const [apePaterno, guardarApePaterno] = useState(simuladorFVG.apePaterno);
  const [msgApePaterno, guardarMsgApePaterno] = useState('');
  const [apeMaterno, guardarApeMaterno] = useState(simuladorFVG.apeMaterno);
  const [msgApeMaterno, guardarMsgApeMaterno] = useState('');
  const [fecNacimiento, guardarFecNacimiento] = useState(
    simuladorFVG.fecNacimiento
  );
  const [msgFecNacimiento, guardarMsgFecNacimiento] = useState('');
  const [genero, guardarGenero] = useState(simuladorFVG.genero);
  const [msgGenero, guardarMsgGenero] = useState('');
  const [celular, guardarCelular] = useState(simuladorFVG.celular);
  const [msgCelular, guardarMsgCelular] = useState('');
  const [correoEle, guardarCorreoEle] = useState(simuladorFVG.correoEle);
  const [msgCorreoEle, guardarMsgCorreoEle] = useState('');
  const [terminos, guardarTerminos] = useState(simuladorFVG.terminos);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onClickGuardarDatos = useCallback(async () => {
    if (!props.mostrarActua && nombre.trim() === '') {
      guardarMsgNombre('El campo es obligatorio');
      return false;
    }

    if (!props.mostrarActua && /\d/.test(nombre)) {
      guardarMsgNombre('El campo no se permite números');
      return false;
    }

    if (!props.mostrarActua && apePaterno.trim() === '') {
      guardarMsgApePaterno('El campo es obligatorio');
      return false;
    }

    if (!props.mostrarActua && /\d/.test(apePaterno)) {
      guardarMsgApePaterno('El campo no se permite números');
      return false;
    }

    if (!props.mostrarActua && apeMaterno.trim() === '') {
      guardarMsgApeMaterno('El campo es obligatorio');
      return false;
    }

    if (!props.mostrarActua && /\d/.test(apeMaterno)) {
      guardarMsgApeMaterno('El campo no se permite números');
      return false;
    }

    if (
      !props.mostrarActua &&
      (fecNacimiento.trim() === '' || fecNacimiento.trim() === '__/__/____')
    ) {
      guardarMsgFecNacimiento('El campo es obligatorio');
      return false;
    }

    if (
      !props.mostrarActua &&
      !validateDateFormat(fecNacimiento, 'dd/MM/yyyy')
    ) {
      guardarMsgFecNacimiento('El campo debe ser una fecha válida');
      return false;
    }

    if (
      !props.mostrarActua &&
      validateAge(fecNacimiento, 'dd/MM/yyyy') <
        process.env.REACT_APP_EDAD_MINIMA
    ) {
      guardarMsgFecNacimiento(
        `La edad mínima de contratación es de ${process.env.REACT_APP_EDAD_MINIMA} años.`
      );
      return false;
    }

    if (
      !props.mostrarActua &&
      validateAge(fecNacimiento, 'dd/MM/yyyy') >
        process.env.REACT_APP_EDAD_MAXIMA
    ) {
      guardarMsgFecNacimiento(
        `La edad máxima de contratación es de ${process.env.REACT_APP_EDAD_MAXIMA} años.`
      );
      return false;
    }

    if (!props.mostrarActua && genero.trim() === '') {
      guardarMsgGenero('El campo es obligatorio');
      return false;
    }

    if (celular.trim() === '') {
      guardarMsgCelular('El campo es obligatorio');
      return false;
    }

    if (celular.length < 9) {
      guardarMsgCelular('Completar el campo');
      return false;
    }

    if (celular.length > 11) {
      guardarMsgCelular('Celular no valido');
      return false;
    }

    if (correoEle.trim() === '') {
      guardarMsgCorreoEle('El campo es obligatorio');
      return false;
    }

    if (!validarCorreo(correoEle.trim())) {
      guardarMsgCorreoEle('El campo debe ser un correo electrónico válido');
      return false;
    }

    dispatch(
      addRegistroDatos({
        nombre: nombre,
        apePaterno: apePaterno,
        apeMaterno: apeMaterno,
        fecNacimiento: fecNacimiento,
        genero: genero,
        celular: celular,
        correoEle: correoEle,
        terminos: terminos,
        terminosConfir: simuladorFVG.terminosConfir,
      })
    );
	const token = await executeRecaptcha('ecowebapp');

    if (process.env.REACT_APP_ACTIVE_VALIDATION_RECAPTCHA === 'true') {
		dispatch(postCaptcha(token)).then((resp) => {
        if (resp.payload.datos.esValido) {
          if (props.mostrarActua === true) {
            dispatch(
              patchActualizarInformacion({
                celular: celular,
                correoEle: correoEle,
                terminos: terminos,
                idSimulacion: simuladorFVG.idSimulacion,
              })
            ).then(() => {
              props.onClose(false);
              history('/simulador');
            });
          } else {
            dispatch(
              postValidarCreatePersona({
                codigoTipoDocumento: simuladorFVG.tipoDocumento,
                numeroDocumento: simuladorFVG.nroDocumento,
                nombre: nombre,
                apellidoPaterno: apePaterno,
                apellidoMaterno: apeMaterno,
                fechaNacimiento: obtenerFechaNacimiento(fecNacimiento),
                genero: genero,
                celular: celular,
                correoEle: correoEle,
                consentimientoInformativo: terminos,
              })
            ).then((resp) => {
              props.onClose(false);
              if (!resp.payload) {
                dispatch(resetState());
              } else {
                history('/simulador');
              }
            });
          }
        } else {
          props.onClose(false);
          dispatch(resetState());
        }
      });
    } else {
      if (props.mostrarActua === true) {
        dispatch(
          patchActualizarInformacion({
            celular: celular,
            correoEle: correoEle,
            terminos: terminos,
            idSimulacion: simuladorFVG.idSimulacion,
          })
        ).then(() => {
          props.onClose(false);
          history('/simulador');
        });
      } else {
        dispatch(
          postValidarCreatePersona({
            codigoTipoDocumento: simuladorFVG.tipoDocumento,
            numeroDocumento: simuladorFVG.nroDocumento,
            nombre: nombre,
            apellidoPaterno: apePaterno,
            apellidoMaterno: apeMaterno,
            fechaNacimiento: obtenerFechaNacimiento(fecNacimiento),
            genero: genero,
            celular: celular,
            correoEle: correoEle,
            consentimientoInformativo: terminos,
          })
        ).then((resp) => {
          props.onClose(false);
          if (!resp.payload) {
            dispatch(resetState());
          } else {
            history('/simulador');
          }
        });
      }
    }
  }, [
    apeMaterno,
    apePaterno,
    celular,
    correoEle,
    dispatch,
    executeRecaptcha,
    fecNacimiento,
    genero,
    history,
    nombre,
    props,
    simuladorFVG.idSimulacion,
    simuladorFVG.nroDocumento,
    simuladorFVG.terminosConfir,
    simuladorFVG.tipoDocumento,
    terminos,
  ]);

  const disableButtonCompleta =
    nombre !== '' &&
    apePaterno !== '' &&
    apeMaterno !== '' &&
    fecNacimiento !== '' &&
    celular !== '' &&
    correoEle !== ''
      ? false
      : true;
  const disableButtonActualiz =
    celular !== '' && correoEle !== '' ? false : true;

  useEffect(() => {
    gtmOnclickCompletarDatos(props.mostrarActua);
  }, [props.mostrarActua]);

  const onClickContinuar = useCallback(() => {
    onClickGuardarDatos();
    gtmOnclickContinuar(props.mostrarActua);
  }, [onClickGuardarDatos, props.mostrarActua]);

  return (
    <div className={classes()}>
      <div className={classes('container')}>
        <div className={classes('content')}>
          <div className={classes('contentImg')}>
            <img src={img_persona_laptop} alt="img_persona_laptop" />
          </div>
          <div className={classes('contentForm')}>
            <img
              className={classes('contentClose')}
              src={ico_cancel_circle}
              alt={'ico_cancel_circle'}
              onClick={() => {
                props.onClose(false);
                dispatch(resetState());
              }}
            />
            <p className={classes('contentTitle')}>
              <b>{props.mostrarActua ? 'Actualiza' : 'Completa'} tus datos</b>
            </p>
            <div>
              {props.mostrarActua ? null : (
                <div>
                  <InputTextComponent
                    inputText={'Nombre'}
                    inputValue={nombre}
                    inputAction={guardarNombre}
                    inputWidth={100}
                    type={'text'}
                    inputMsg={msgNombre}
                    inputActionMsg={guardarMsgNombre}
                    styleText={'capitalize'}
                  />
                  <div className={classes('contentDiv')}>
                    <InputTextComponent
                      inputText={'Apellido paterno'}
                      inputValue={apePaterno}
                      inputAction={guardarApePaterno}
                      inputWidth={48}
                      type={'text'}
                      inputMsg={msgApePaterno}
                      inputActionMsg={guardarMsgApePaterno}
                      styleText={'capitalize'}
                    />
                    <InputTextComponent
                      inputText={'Apellido materno'}
                      inputValue={apeMaterno}
                      inputAction={guardarApeMaterno}
                      inputWidth={48}
                      type={'text'}
                      inputMsg={msgApeMaterno}
                      inputActionMsg={guardarMsgApeMaterno}
                      styleText={'capitalize'}
                    />
                  </div>
                  <div className={classes('contentDiv')}>
                    <InputDateComponent
                      inputText={'Fecha de nacimiento'}
                      inputValue={fecNacimiento}
                      inputAction={guardarFecNacimiento}
                      inputWidth={48}
                      inputMsg={msgFecNacimiento}
                      inputActionMsg={guardarMsgFecNacimiento}
                    />
                    <InputSelectComponent
                      inputText={'Género'}
                      inputValue={genero}
                      inputAction={guardarGenero}
                      inputWidth={48}
                      inputMsg={msgGenero}
                      inputActionMsg={guardarMsgGenero}
                    />
                  </div>
                </div>
              )}
              <InputTextComponent
                inputText={'Celular'}
                inputValue={celular}
                inputAction={guardarCelular}
                inputWidth={100}
                type={'number'}
                inputMsg={msgCelular}
                inputActionMsg={guardarMsgCelular}
              />
              <InputTextComponent
                inputText={'Correo'}
                inputValue={correoEle}
                inputAction={guardarCorreoEle}
                inputWidth={100}
                type={''}
                inputMsg={msgCorreoEle}
                inputActionMsg={guardarMsgCorreoEle}
              />
              <InputCheckComponent
                inputValue={terminos}
                inputAction={guardarTerminos}
                inputText={[
                  <a
                    key={'linkTerminos'}
                    className={classes('inputCheckLink')}
                    target="_blank"
                    href="https://www.pacifico.com.pe/terminos-condiciones-ecommerce"
                    rel="noreferrer"
                  >
                    {' '}
                    He leído y acepto las condiciones establecidas en la
                    cláusula de{' '}
                    <span className={classes('inputCheckSpan')}>
                      protección de datos personales.
                    </span>
                  </a>,
                ]}
              />
              <div className={classes('contentButton')}>
                <ButtonComponent
                  type="button"
                  label={'btnContinuarRegistro'}
                  tipo={'button-red'}
                  disabled={
                    props.mostrarActua
                      ? disableButtonActualiz
                      : disableButtonCompleta
                  }
                  action={onClickContinuar}
                  nombre={'Continuar'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDatosPersonalesComponent;
